// extracted by mini-css-extract-plugin
export default {"badge":"ProductBadge_badge__usQud","new":"ProductBadge_new__ug0IS","sold":"ProductBadge_sold__32O8D","reserved":"ProductBadge_reserved__YcqYl"};